import VueGtag from 'vue-gtag';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './i18n';
import './shared/vue';

Vue.use(VueGtag, {
  config: { id: 'G-JSPTB2H75F' },
  bootstrap: false
}, router);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
